import React from "react";
import { Box, Grid, IconButton, Typography } from "@tiny/components";
import CloseSmall from "@tiny/icons/generated/CloseSmall";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useAudienceSourceDetails } from "./AudienceSourceDetails.hooks";
import AudienceDetailsStatistics from "../AudienceDetailsStatistics";
import SubscribersList from "../../components/SubscribersList";
import AudienceSourceDetailsHeader from "./AudienceSourceDetailsHeader";
import { TinyImporter } from "../../components/TinyImportDialog";
import { useRefresh } from "@tiny/components/src/RefreshProvider";
import useTinyImporter from "../../hooks/useTinyImporter";
import CustomerEngagementLevels from "../../components/CustomerEngagementLevels";
import { useTinyHost } from "@tiny/host-contract";

function AudienceSourceDetails({ segmentId: segmentIdProp }) {
  const { mdUp, lgUp } = useBreakpoints();
  const { navigate } = useTinyHost();
  const [bannerDismissed, setBannerDismissed] = React.useState(false);

  const { openTinyImporter, closeTinyImporter, tinyImporterOpen } =
    useTinyImporter();

  const {
    segmentDetails,
    segmentId,
    refetchSegmentDetails,
    enableEdit,
    isSegmentLoading,
  } = useAudienceSourceDetails(segmentIdProp);

  return (
    <>
      <Box overflow={{ xs: "hidden", lg: "initial" }}>
        <AudienceSourceDetailsHeader
          onSaveTitle={refetchSegmentDetails}
          title={segmentDetails?.name}
          segmentId={segmentId}
          segmentType={segmentDetails?.segmentType}
          importDisabled={!enableEdit}
          onImport={openTinyImporter}
          enableEdit={!isSegmentLoading}
          status={segmentDetails?.status}
          cleaned={segmentDetails?.cleaned}
        />
        <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
          <Grid item xs={12}>
            <AudienceDetailsStatistics
              segmentDetails={segmentDetails}
              all={false}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomerEngagementLevels
              segmentIds={segmentId ? [segmentId] : []}
            />
          </Grid>
          {!bannerDismissed && (
            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                bgcolor="#f0fdfa"
                borderLeft="4px solid #14b8a6"
                px={5}
                py={4}
                style={{
                  borderRadius: "0 8px 8px 0",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                }}
              >
                <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bgcolor="#ccfbf1"
                    style={{
                      borderRadius: "50%",
                      color: "#0d9488",
                      flexShrink: 0,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        clipRule="evenodd"
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      />
                    </svg>
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="grey"
                      tone={900}
                    >
                      Check Audience History
                    </Typography>
                    <Typography
                      variant="body3"
                      color="primary"
                      tone="main"
                      component={"div"}
                    >
                      Click <strong>View history </strong> or any{" "}
                      <strong>Email Address</strong> to view their contact
                      details, activity timeline, and email engagement.
                    </Typography>
                  </Box>
                </Box>
                <IconButton
                  size="small"
                  onClick={() => setBannerDismissed(true)}
                  style={{ color: "#0d9488" }}
                >
                  <CloseSmall />
                </IconButton>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <SubscribersList
              pageName="audienceSourceDetails"
              segmentId={segmentId}
              segmentType={segmentDetails?.segmentType}
              bgcolor="white"
              borderRadius={mdUp ? "8px" : "0px"}
              showChip
              onAfterDelete={refetchSegmentDetails}
              enableEdit={enableEdit}
            />
          </Grid>
        </Grid>
      </Box>
      <TinyImporter
        open={tinyImporterOpen}
        onClose={closeTinyImporter}
        value={segmentDetails?.name}
        segmentDetails={segmentDetails}
        onSuccess={() => {
          closeTinyImporter();
          navigate.to("/main/audience");
        }}
      />
    </>
  );
}

export default AudienceSourceDetails;
